import React from 'react'
import { Divider } from '@material-ui/core'
import styled from 'styled-components'
import { spacing } from '@material-ui/system'

export default styled(Divider)(spacing)
